import Api from "./api";
import * as Constants from "../../../../consts/Constants.js";
import auth from "../../../auth/service";

const PHARMACY_ADMIN_ROLE = 5010;

class PharmaciesService {

	constructor(baseUrl) {
		this.api = new Api(baseUrl);
	}

	canAdmin() {
		return auth.hasRole(PHARMACY_ADMIN_ROLE);
	}

	canAccess() {
		return auth.isCitizen();
	}

}

export default new PharmaciesService(Constants.FINAL_URL_MAP_PLACES);